if (!customElements.get('product-description-toggle')) {
  customElements.define(
    'product-description-toggle',
    class ProductDescriptionToggle extends HTMLElement {
      constructor() {
        super();

        this.toggleBtn = this.querySelector('[data-toggle]');
        this.excerpt = this.querySelector('[data-excerpt]');
        this.full = this.querySelector('[data-full]');

        if (!this.toggleBtn || !this.excerpt || !this.full) return;

        this.showMoreLabel = this.dataset.showMore || 'Show more';
        this.showLessLabel = this.dataset.showLess || 'Show less';
        this.expanded = false;

        this.toggleBtn.addEventListener('click', this.onToggle.bind(this));
      }

      onToggle() {
        this.expanded = !this.expanded;
        this.excerpt.classList.toggle('hidden', this.expanded);
        this.full.classList.toggle('hidden', !this.expanded);
        this.toggleBtn.textContent = this.expanded
          ? this.showLessLabel
          : this.showMoreLabel;
        this.toggleBtn.setAttribute('aria-expanded', this.expanded);
      }
    }
  );
}
